import React from "react";


const NotFoundPage = () => {
    return <>NotFoundPage</>
}

export default NotFoundPage;